import { c as _c } from "react/compiler-runtime";
import type { AgentKind, Entity, UserTimelineEventAgentExecution } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import AGENT_ICONS, { AGENT_ICON_COMPONENTS, DEFAULT_AGENT_ICON } from '@/components/agent-icon-picker/agent-icons';
import { agentBuilderUrl } from '@/config/constants';
import useDocumentsQueryParams from '@/entity/hooks/use-documents-query-params';
import { SHOW_INVESTIGATION_KINDS } from '../agent-execution-started-event-header';
type AgentExecutionEventHeaderProps = {
  data: UserTimelineEventAgentExecution['data'];
  entity: Entity;
};
const AgentExecutionCompletedEventHeader = t0 => {
  const $ = _c(51);
  const {
    data
  } = t0;
  const {
    kind,
    investigationId
  } = data;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.agentExecutionEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== data.agentName || $[2] !== data.agentVersionTag || $[3] !== t) {
    const name = data.agentName ?? t(_temp);
    t2 = data.agentVersionTag ? t(_temp2, {
      name,
      version: data.agentVersionTag
    }) : name;
    $[1] = data.agentName;
    $[2] = data.agentVersionTag;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const agentLabel = t2;
  const iconKey = AGENT_ICONS.find(i => i === data.agentIcon) ?? DEFAULT_AGENT_ICON;
  const Icon = AGENT_ICON_COMPONENTS[iconKey];
  const docDetailsQueryParams = useDocumentsQueryParams();
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp6);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp7);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp8);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = {
      watchlist_review: t3,
      document_extraction: t4,
      research: t5,
      decision: t6,
      document_verification: t7,
      copilot: t8
    };
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const kindToDescription = t9;
  const isDocumentAgent = data.kind === "document_extraction" || data.kind === "document_verification";
  let t10;
  if ($[24] !== data.documentIdentifier || $[25] !== docDetailsQueryParams || $[26] !== isDocumentAgent) {
    t10 = () => {
      if (isDocumentAgent && data.documentIdentifier) {
        docDetailsQueryParams.push(data.documentIdentifier);
      }
    };
    $[24] = data.documentIdentifier;
    $[25] = docDetailsQueryParams;
    $[26] = isDocumentAgent;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const handleViewDocumentDetails = t10;
  let t11;
  if ($[28] !== Icon) {
    t11 = <div className="flex items-center size-4 shrink-0 [&>svg]:size-4"><Icon /></div>;
    $[28] = Icon;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== agentLabel || $[31] !== data.agentId || $[32] !== data.agentVersionId) {
    t12 = data.agentId ? <LinkButton href={agentBuilderUrl(data.agentId, {
      versionId: data.agentVersionId
    })} className="text-label-2">{agentLabel}</LinkButton> : <span className="text-label-2 text-primary">{agentLabel}</span>;
    $[30] = agentLabel;
    $[31] = data.agentId;
    $[32] = data.agentVersionId;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const t13 = kindToDescription[data.kind];
  let t14;
  if ($[34] !== t13) {
    t14 = <span className="text-body-2 text-tertiary">{t13}</span>;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== investigationId || $[37] !== kind || $[38] !== t) {
    t15 = investigationId && SHOW_INVESTIGATION_KINDS.includes(kind) && <><div className="flex items-center justify-center mx-0.5">·</div><LinkButton href={`/investigations/${investigationId}`} target="_blank">{t(_temp9)}</LinkButton></>;
    $[36] = investigationId;
    $[37] = kind;
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== data.documentIdentifier || $[41] !== handleViewDocumentDetails || $[42] !== isDocumentAgent || $[43] !== t) {
    t16 = isDocumentAgent && data.documentIdentifier && <><div className="flex items-center justify-center mx-0.5">·</div><LinkButton onClick={handleViewDocumentDetails}>{t(_temp10)}</LinkButton></>;
    $[40] = data.documentIdentifier;
    $[41] = handleViewDocumentDetails;
    $[42] = isDocumentAgent;
    $[43] = t;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t11 || $[46] !== t12 || $[47] !== t14 || $[48] !== t15 || $[49] !== t16) {
    t17 = <div className="flex flex-wrap items-center gap-1 md:flex-nowrap">{t11}{t12}{t14}{t15}{t16}</div>;
    $[45] = t11;
    $[46] = t12;
    $[47] = t14;
    $[48] = t15;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  return t17;
};
export default AgentExecutionCompletedEventHeader;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.agentWithVersion;
}
function _temp3($_1) {
  return $_1.description.watchlistReview;
}
function _temp4($_2) {
  return $_2.description.documentExtraction;
}
function _temp5($_3) {
  return $_3.description.research;
}
function _temp6($_4) {
  return $_4.description.decision;
}
function _temp7($_5) {
  return $_5.description.documentVerification;
}
function _temp8($_6) {
  return $_6.description.copilot;
}
function _temp9($_7) {
  return $_7.viewInvestigation;
}
function _temp10($_8) {
  return $_8.viewDetails;
}